import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

const NETWORK_ERROR_MESSAGE =
  'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.logError(request, error)
        if (error.status === 0) {
          return throwError(
            () =>
              new HttpErrorResponse({
                error: NETWORK_ERROR_MESSAGE,
                status: error.status,
                statusText: error.statusText,
                url: error.url ?? undefined,
              })
          )
        }
        return throwError(() => error)
      })
    )
  }

  private logError(request: HttpRequest<unknown>, error: HttpErrorResponse): void {
    if (error.status === 0) {
      console.error(
        `[HTTP] Falha de rede em ${request.method} ${request.url}`,
        error
      )
      return
    }
    console.error(
      `[HTTP ${error.status}] ${request.method} ${request.url}`,
      error.error ?? error.message
    )
  }
}
